<template>
  <a href="javascript:void(0);" data-href="href" @click.prevent.stop="show(), $emit('get-result', $event)" @click.middle.prevent="showMiddle" v-if="preventMiddleClick">
    <slot></slot>
  </a>
  <a :href="href" @click.prevent.stop="show(), $emit('get-result', $event)" v-else>
    <slot></slot>
  </a>
</template>

<script>
  import $ from 'jquery';
  import Vue from 'vue';
  import sweetalert from 'sweetalert';

  export default {
    computed: {

    },
    data() {
      return {};
    },
    methods: {
      selectLang(lang) {
        window.app.$store.commit('SET_INPUTING_LOCALE', lang.code)
      },
      showMiddle(event) {
        if (this.preventMiddleClick) {
          event.preventDefault();
          event.stopPropagation();
          this.show();
        }
      },
      show() {
        let that = this;
        $('.func-scroll-to-top-btn').fadeOut();
        if(that.data){
          window.app.data = that.data;
        }
        window.app.methods.showLoader();

        if (this.beforeShowState) {
          var oldUrl = document.querySelector('.func-respond-all-btn').getAttribute('href'),
            newUrl,
            $formData = $('.func-table-responsive input:checkbox').serialize();

          if ($formData) {
            newUrl = oldUrl + '?respond=&' + $formData;
          } else {
            return;
          }
        }

        $.ajax({
          url: !this.beforeShowState ? this.href : newUrl,
          method: this.method,
          data: typeof this.data === 'function' ? this.data() : this.data,
          success: (response) => {
            if (response && response.error) {
              sweetalert(response.title, response.message, 'error');
              window.app.methods.hideLoader();
              return true;
            }
            this.$emit('showstart');



            let responseData = false;
            let scriptTagIndex = response.indexOf('<script>');
            let closingScriptTagIndex = response.indexOf('<\/script>');
            let validResponseString = response;

             let alternateScriptTagIndex = response.indexOf('<script type="text/javascript">');

            if (scriptTagIndex !== -1 || alternateScriptTagIndex !== -1) {
              if(scriptTagIndex !== -1){
                validResponseString = response.substr(0, scriptTagIndex);
                responseData = response.substring(scriptTagIndex + 8, closingScriptTagIndex);
              }else if(alternateScriptTagIndex !== -1){
                validResponseString = response.substr(0, alternateScriptTagIndex);
                responseData = response.substring(alternateScriptTagIndex + 31, closingScriptTagIndex);
              }
            }
              responseData = responseData.replaceAll('<script type="text/javascript">', '').replaceAll('<script>', '').replaceAll('<\/script>', '');

            let parser = new DOMParser;
            let dom = parser.parseFromString(validResponseString, "text/html");
            if (responseData) {
              eval(responseData);
            }
            let modal = Vue.component('modalComp', {
              template: `<div class='edit-modal-content' style="overflow-y: scroll; height: 100%;">
                            ${dom.body.innerHTML}
                            <button class="func-scroll-to-top-btn-popup scroll-to-top-btn scroll-to-top-btn--popup" type="button" style="display: none;"></button>
                        </div>`,
              data: function () {

                let boundMethods = {};
                if (responseData) {
                  eval(responseData);

                  for (let methodName in window.app.methods) {
                    boundMethods[methodName] = window.app.methods[methodName].bind(this);
                  }
                }

                return {
                  isModal: true,
                  ...window.app.data,
                  ...boundMethods,
                  locales: window.app.locales,
                  metadata: window.app.metadata
                }
              },
              computed: window.app.computed,
              components: window.app.$options.components,
              created() {
                this.$root.$on('closeDynamicModal', () => {
                  let popups = [...document.querySelectorAll('.v--modal-overlay')];

                  if (popups.length < 2) {
                    this.$emit('close');
                  } else {
                    this.$root.$modal.hide(popups[popups.length - 1].getAttribute('data-modal'));
                  }
                });
                this.$validator = this.$root.$validator;
              }
            });

            this.$modal.show(modal, {}, {
              resizable: true,
              width: '90%',
              height: '90%',
              minWidth: 1000,
              minHeight: 490
            }, {
              opened: () => {
                this.$root.$emit('modalOpened', this);
                let modalEl = $('.edit-modal-content');
                modalEl.each(function (el) {
                  $(el).css('padding-top', $(el).find('.sticky').height());
                });

                if (this.helperClass) {
                  this.toggleHelperClass();
                }

                $(window).on('resize', function () {
                  modalEl.each(function (el) {
                    $(el).css('padding-top', $(el).find('.sticky').height());
                  });
                })

                let cards = modalEl.find('.v-card');
                let formOffsetTop = modalEl.find('#form').length ? modalEl.find('#form').offset().top : 0;
                let cardsList = [];
                for (var i = 0; i < cards.length; i++) {
                  let id = $(cards[i]).find('.v-card__vertical-position').attr('id');
                  cardsList.push(id);
                }

                cardsList = cardsList.filter(Boolean); // prevent empty string in array

                function setScrollPosition() {
                  for (var i = 0; i < cardsList.length; i++) {
                    if (cardsList.length == i + 1 || $('#' + cardsList[i]).offset().top < formOffsetTop && $('#' + cardsList[i + 1]).offset().top >= formOffsetTop) {

                      if ($(modalEl).hasClass('scrolling')) return;

                      if ($(modalEl).outerHeight(true) + $(modalEl).scrollTop() >= $(modalEl).find('[role="main"]').outerHeight(true)) {
                        return location.replace('#_' + cardsList[cardsList.length - 1]);
                      } else {
                        return location.replace('#_' + cardsList[i]);
                      }
                    }
                  }
                }

                if (that.isHashChangeEnabled) {
                  modalEl.on('scroll', function () {
                    setScrollPosition();
                  });
                }

                $('.edit-modal-content').scroll(function () {
                  if ($(this).scrollTop() >= 200) {
                    $(this).find($('.func-scroll-to-top-btn-popup').fadeIn());
                  } else {
                    $(this).find($('.func-scroll-to-top-btn-popup').fadeOut());
                  }
                });

                $(document).on('click', '.func-scroll-to-top-btn-popup', function () {
                  $($(this).parents('.edit-modal-content')).animate({
                    scrollTop: 0
                  }, 700);
                });

                window.app.methods.hideLoader();

              },
              closed: (event) => {
                if ($('.edit-modal-content').length == 1) {
                  $('.func-scroll-to-top-btn').fadeIn();
                }

                this.$root.$emit('modalClosed', this.modalClass, this);

                if (this.helperClass) {
                  this.toggleHelperClass();
                }
                window.app.methods.hideLoader();

                if (window.app.data && window.app.data.reloadAfterClose) {
                  location.reload();
                }
              }
            });
          }
        })
      },
      toggleHelperClass() {
        document.getElementById('modals-container').classList.toggle('modals-wrap');
      }
    },
    props: {
      href: {
        default: true,
        type: String,
      },
      modalClass: {
        default: '',
        type: String,
      },
      method: {
        default: "get",
        type: String
      },
      data: {
        default: () => { },
        type: [Object, Function]
      },
      beforeShowState: {
        default: false,
        type: Boolean
      },
      helperClass: {
        default: false,
        type: Boolean
      },
      preventMiddleClick: {
        default: false,
        type: Boolean
      },
      isHashChangeEnabled: {
        default: true,
        type: Boolean
      }
    },
    watch: {
      // data(value) {
      //   if(!window.app.data){
      //     window.app.data = value;
      //   }
      //   for (let d in value) {
      //     if(value.hasOwnProperty(d) && value[d] !== undefined){
      //       window.app.data[d] = value[d];
      //     }
      //   }
      //   // window.app.data = value;
      // }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VModalLink.vue